import React, { useState, useEffect, useRef, useCallback } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import './index.css';

/* ─── ASSETS ──────────────────────────────────────────────────────── */
const IMAGES = {
  hero:  '/assets/images/image11.jpeg',
  phil:  '/assets/images/image1.jpeg',
  gallery: [
    '/assets/images/image11.jpeg', '/assets/images/image8.jpeg',
    '/assets/images/image3.jpeg',  '/assets/images/image2.jpeg',
    '/assets/images/image15.jpeg', '/assets/images/image7.jpeg',
    '/assets/images/WhatsApp_Image_2026-04-14_at_4_38_18_PM.jpeg',
    '/assets/images/image14.jpeg', '/assets/images/image9.jpeg',
    '/assets/images/image13.jpeg', '/assets/images/image16.jpeg',
    '/assets/images/image17.jpeg',
  ],
  tools1: '/assets/images/tools2.jpg',
  tools2: '/assets/images/tools1.jpg',
};
const VIDEOS = [
  { src:'/assets/videos/video1.mp4', label:'Session I' },
  { src:'/assets/videos/video2.mp4', label:'Session II' },
  { src:'/assets/videos/video3.mp4', label:'Session III' },
  { src:'/assets/videos/video4.mp4', label:'Session IV' },
];

/* ─── SVG ICONS ───────────────────────────────────────────────────── */
const Icons = {
  instagram:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none"/></svg>,
  twitter:  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  tiktok:   <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/></svg>,
  facebook: <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
  zangi:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  email:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,14 22,4"/></svg>,
  throne:   <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z"/></svg>,
  giftcard: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="22" height="22"><rect x="1" y="8" width="22" height="13" rx="2"/><line x1="1" y1="13" x2="23" y2="13"/><path d="M12 8V2M8 2c0 0 0 4 4 6M16 2c0 0 0 4-4 6"/></svg>,
  bitcoin:  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M17.06 11.57c.59-.69.94-1.59.94-2.57 0-2.21-1.79-4-4-4V3h-2v2H10V3H8v2H5v2h2v10H5v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.11-.43-2.12-1.94-3.43zm-7.06-4.57h4c1.1 0 2 .9 2 2s-.9 2-2 2H10V7zm4 10h-4v-4h4c1.1 0 2 .9 2 2s-.9 2-2 2z"/></svg>,
  warn:     <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>,
  clock:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" width="18" height="18"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>,
  star:     <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  cancel:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" width="18" height="18"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
  check:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><polyline points="20,6 9,17 4,12"/></svg>,
};

/* ─── SOCIALS DATA ─────────────────────────────────────────────────── */
const SOCIALS = [
  { id:'instagram', label:'Instagram',  handle:'@goddessnatasha000',       href:'https://instagram.com/goddessnatasha000', icon:Icons.instagram, color:'#E1306C' },
  { id:'twitter',   label:'X / Twitter',handle:'@DommeNatasha001',         href:'https://twitter.com/DommeNatasha001',    icon:Icons.twitter,   color:'#1DA1F2' },
  { id:'tiktok',    label:'TikTok',     handle:'Coming Soon',               href:null,                                     icon:Icons.tiktok,    color:'#69C9D0' },
  { id:'facebook',  label:'Facebook',   handle:'Coming Soon',               href:null,                                     icon:Icons.facebook,  color:'#1877F2' },
  { id:'zangi',     label:'Zangi',      handle:'5815960601',                href:'https://zangi.com',                      icon:Icons.zangi,     color:'#00BCD4' },
  { id:'email',     label:'Email',      handle:'natashabates001@gmail.com', href:'mailto:natashabates001@gmail.com',       icon:Icons.email,     color:'#C5A059' },
];

const PAYMENTS = [
  { id:'throne',   label:'Throne Wishlist', icon:Icons.throne,   detail:'throne.com/domqueen00',          href:'https://throne.com/domqueen00', desc:'Send gifts directly from Her wishlist', cta:'View Wishlist', copyable:false },
  { id:'giftcard', label:'Gift Cards',       icon:Icons.giftcard, detail:'natashabates001@gmail.com',              href:'mailto:natashabates001@gmail.com?subject=Gift%20Card%20Tribute', desc:'Amazon, Steam, Google Play & more', cta:'Send Gift Card', copyable:false },
  { id:'bitcoin',  label:'Bitcoin (BTC)',    icon:Icons.bitcoin,  detail:'3AP8cKbZsGSGzLZ7tG2DErH31kJsj3b673',    href:null, desc:'Crypto tribute — fully anonymous', cta:'Copy Address', copyable:true },
];

/* ─── SESSION CATEGORIES ───────────────────────────────────────────── */
const SESSION_CATEGORIES = [
  {
    title: 'Bondage & Restraint',
    icon: '⛓',
    items: ['Bondage', 'Mummification', 'Total sensory deprivation', 'Chastity cage', 'Enforced chastity', 'Permanent chastity', 'Corset training & extreme tightlacing', 'Leather restraint', 'Latex total encasement', 'Rubber breath restriction'],
  },
  {
    title: 'Discipline & Impact',
    icon: '🔴',
    items: ['Discipline', 'Spanking', 'Whipping', 'Caning', 'Severe beating', 'Brutal flogging', 'Hair pulling', 'Trampling with full weight', 'Boot worship', 'Brat taming with punishment'],
  },
  {
    title: 'Domination & Submission',
    icon: '👑',
    items: ['Domination & submission', 'Master / slave dynamics', 'Slave play', 'Objectification', 'Human furniture', 'Financial ruin', 'Voice restraint with gagging torture', 'Switch with cruel topping'],
  },
  {
    title: 'Humiliation & Degradation',
    icon: '🖤',
    items: ['Degradation', 'Extreme humiliation', 'Toilet humiliation', 'Cuckolding with humiliation', 'Sissification', 'Forced feminization', 'Dollification', 'Adult baby with diaper humiliation', 'Human ashtray', 'Cuckooing with humiliation'],
  },
  {
    title: 'Sensation & Torture',
    icon: '⚡',
    items: ['Sadism & masochism', 'Nipple torture', 'Clamp torture', 'Wax torture', 'Temperature extremes (ice & fire)', 'Electro torture', 'Sensory overload', 'Forced laughter — tickling torture', 'Edge play', 'Medical play with invasive procedures'],
  },
  {
    title: 'Genital Torture (CBT)',
    icon: '🔒',
    items: ['Extreme CBT', 'Ballbusting', 'Cock torture', 'Ball crushing', 'Sounding with large rods', 'Urethral stretching', 'Electro genital torture', 'Genital mutilation fantasy (roleplay)', '— [Placeholder for additional practice]', '— [Placeholder for additional practice]'],
    warning: true,
  },
  {
    title: 'Breath & Choking',
    icon: '💨',
    items: ['Choking', 'Breath play', 'Erotic asphyxiation', 'Breath restraint to edge', 'Rubber breath restriction', '— [Placeholder for additional practice]'],
    warning: true,
  },
  {
    title: 'Body Worship & Fetish',
    icon: '👣',
    items: ['Feet worship', 'Toe jam & dead skin licking', 'Ass worship', 'Rimming / rimjob', 'Boot worship', 'Leather fetish with heavy restraint', 'Latex fetish', 'Rubber fetish', 'Hair fetish with pulling & burning', 'Corset fetish'],
  },
  {
    title: 'Pet & Role Play',
    icon: '🐾',
    items: ['Pet play with extreme training', 'Pony play with harsh bits', 'Puppy play with cage discipline', 'Doll play with rigid posing', 'Giantess fantasy with crushing', 'Medical roleplay', 'Brat taming', 'Switch dynamics'],
  },
  {
    title: 'Extreme & Edge Play',
    icon: '⚠',
    items: ['Needle play', 'Piercing play', 'Knife play', 'Fire play', 'Razor play', 'Blood play / cutting', 'Temporary branding / tattooing', 'Enema torture', '— [Placeholder — edit before publishing]', '— [Placeholder — edit before publishing]'],
    warning: true,
  },
  {
    title: 'Watersports & Filth',
    icon: '💧',
    items: ['Watersports', 'Human toilet', 'Scat play', 'Toilet humiliation', 'Sploshing with filth', 'Food play with degradation', '— [Placeholder — edit before publishing]'],
    warning: true,
  },
  {
    title: 'Insertion & Stretching',
    icon: '🔴',
    items: ['Butt plug', 'Large insertion', 'Fisting', 'Gaping', 'Sounding', 'Urethral stretching', 'Enema torture', '— [Placeholder — edit before publishing]'],
    warning: true,
  },
  {
    title: 'Forced & Financial',
    icon: '💰',
    items: ['Financial ruin', 'Forced intoxication', 'Forced feminization', 'Enforced chastity', 'Financial domination', 'Tribute & gifting rituals', 'Blackmail fantasy (consensual)', '— [Placeholder]'],
  },
  {
    title: 'Miscellaneous Fetishes',
    icon: '✦',
    items: ['Balloon fetish with popping pain', 'Sploshing', 'Food play', 'Objectification', 'Human ashtray', 'Sexual fetish (discuss privately)', 'Sensory overload', 'Mummification', 'Rubber encasement', 'Temperature play'],
  },
];

/* ─── SESSION PRICES ───────────────────────────────────────────────── */
const PRICES = [
  { duration:'1 Hour',    price:'250',        note:'Single session' },
  { duration:'2 Hours',   price:'400',        note:'Extended session' },
  { duration:'3 Hours',   price:'550',        note:'Deep exploration' },
  { duration:'4 Hours',   price:'700',        note:'Immersive experience' },
  { duration:'5 Hours',   price:'800',        note:'Full surrender' },
  { duration:'Overnight', price:'800 – 1600', note:'Depending on kinks explored' },
];

/* ─── TESTIMONIALS ─────────────────────────────────────────────────── */
const TESTIMONIALS = [
  { name:'Marcus R.',   quote:'Goddess Natasha commanded the session with a precision that left me completely undone. Every boundary I set was respected, yet She pushed me to edges I never imagined I could reach. I left transformed.' },
  { name:'James T.',    quote:'I have visited professional Dommes across three countries. None of them compare. Her presence is magnetic. Her control is absolute. I was completely at Her mercy within minutes of arriving.' },
  { name:'David K.',    quote:'The session exceeded every expectation. She read me perfectly — knowing when to be relentless and when to pull back. It felt like She could see directly into my psychology. Extraordinary.' },
  { name:'Thomas W.',   quote:'I was nervous for my first session. She put me at ease before making me utterly helpless. The combination of warmth and cruelty is something I have never encountered before. Truly exceptional.' },
  { name:'Leon A.',     quote:'From the first message to the final moment of the session, the professionalism was impeccable. I was treated like property — exactly as I had requested — and She delivered with elegance and authority.' },
  { name:'Samuel E.',   quote:'Her CBT work is legendary among the community and now I understand why. Clinical, deliberate, and devastating. I begged for mercy more times than I can count. She gave none. Perfect.' },
  { name:'Oliver P.',   quote:'The impact play session was everything I hoped for and more. The progression from warm-up to the most intense flogging I have ever received was masterfully paced. My back still reminds me of Her days later.' },
  { name:'Nathan C.',   quote:'I have been a devoted sub for twelve years. Goddess Natasha is in a class entirely Her own. The psychological depth She brings to humiliation is unlike anything I have experienced. I am utterly addicted.' },
  { name:'Patrick M.',  quote:'What sets Her apart is the artistry. Most Dommes use pain. She uses pain as a language, and She speaks it fluently. The session felt like a performance and I was Her instrument.' },
  { name:'Richard B.',  quote:'Three sessions in and She already knows my body and mind better than I do. Her instincts are frightening. I arrived as a man with limits and left as a devotee with none I would refuse Her.' },
  { name:'Sebastian N.',quote:'The bondage work alone is worth travelling across the continent for. Tight, elegant, inescapable. I spent two hours in perfect helplessness under Her total control. Nothing compares.' },
  { name:'Christian A.',quote:'She creates an atmosphere that is simultaneously terrifying and intimate. I felt completely safe surrendering everything to Her. That paradox is the mark of a true professional. I will return without question.' },
];

/* ─── DESIGN TOKENS ────────────────────────────────────────────────── */
const T = {
  gold:'#C5A059', goldL:'#D4B87A', goldD:'#8B6E3A',
  bg:'#0B0B0B', bg2:'#111111', bg3:'#161616',
  text:'#E8E0D0', textM:'#8A7D6E', textD:'#4A4238',
  border:'rgba(197,160,89,0.15)', borderH:'rgba(197,160,89,0.4)',
  red:'#8B1A1A', redL:'#C0392B',
};

/* ─── ANIMATION VARIANTS ────────────────────────────────────────────── */
const fadeUp    = { hidden:{opacity:0,y:28}, visible:(d=0)=>({opacity:1,y:0,transition:{duration:0.85,delay:d,ease:[0.25,0.46,0.45,0.94]}}) };
const fadeLeft  = { hidden:{opacity:0,x:-28}, visible:{opacity:1,x:0,transition:{duration:0.85,ease:[0.25,0.46,0.45,0.94]}} };
const fadeRight = { hidden:{opacity:0,x: 28}, visible:{opacity:1,x:0,transition:{duration:0.85,ease:[0.25,0.46,0.45,0.94]}} };

function Reveal({ children, variants=fadeUp, custom=0, style, className }) {
  const ref=useRef(null);
  const inV=useInView(ref,{once:true,margin:'-50px'});
  return <motion.div ref={ref} initial="hidden" animate={inV?'visible':'hidden'} variants={variants} custom={custom} style={style} className={className}>{children}</motion.div>;
}

/* ─── SHARED UI ─────────────────────────────────────────────────────── */
function SLabel({children}){return <span style={{fontSize:'0.58rem',letterSpacing:'0.42em',textTransform:'uppercase',color:T.gold,marginBottom:'0.85rem',display:'block'}}>{children}</span>;}
function SHeader({label,title,sub}){
  return(
    <div style={{textAlign:'center',marginBottom:'3rem'}}>
      <SLabel>{label}</SLabel>
      <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(2.2rem,6vw,3.8rem)',fontWeight:300,lineHeight:1.1,color:'#fff'}}>{title}</h2>
      <div style={{width:36,height:1,background:T.gold,margin:'1.1rem auto'}}/>
      {sub&&<p style={{fontSize:'0.75rem',color:T.textM,maxWidth:460,margin:'0 auto',letterSpacing:'0.05em',lineHeight:2}}>{sub}</p>}
    </div>
  );
}
function Ornament(){return <div style={{textAlign:'center',margin:'2.5rem 0',color:T.goldD,fontFamily:"'Cormorant Garamond',serif",letterSpacing:'0.3em',fontSize:'0.9rem'}}>✦ &nbsp; ✦ &nbsp; ✦</div>;}

function Btn({href,solid,children,onClick,small}){
  const [h,setH]=useState(false);
  const pad=small?'0.65rem 1.3rem':'0.85rem 1.8rem';
  const style={fontFamily:"'Montserrat',sans-serif",fontSize:'0.58rem',letterSpacing:'0.2em',textTransform:'uppercase',padding:pad,display:'inline-block',fontWeight:solid?500:300,transition:'all .3s',cursor:'pointer',textDecoration:'none',border:`1px solid ${h?T.gold:T.goldD}`,background:solid?(h?T.goldL:T.gold):(h?'rgba(197,160,89,0.07)':'transparent'),color:solid?T.bg:T.gold,transform:h?'translateY(-2px)':'none'};
  const ev={onMouseEnter:()=>setH(true),onMouseLeave:()=>setH(false)};
  if(onClick)return <button {...ev} onClick={onClick} style={style}>{children}</button>;
  return <a href={href} {...ev} style={style}>{children}</a>;
}

/* ════════════════════════════════════════════════════════════════════
   WARNING MODAL — centered card, scrollable on small screens
════════════════════════════════════════════════════════════════════ */
function WarningModal(){
  const [open,setOpen]=useState(false);
  useEffect(()=>{
    const seen=sessionStorage.getItem('gn_warning');
    if(!seen) setOpen(true);
  },[]);
  const dismiss=()=>{ setOpen(false); sessionStorage.setItem('gn_warning','1'); };

  return(
    <AnimatePresence>
      {open&&(
        /* Backdrop — fixed, full screen, dark overlay */
        <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
          style={{
            position:'fixed', inset:0, zIndex:500,
            background:'rgba(0,0,0,0.82)',
            overflowY:'auto',           /* let the page scroll if modal is tall on tiny screens */
            display:'flex',
            alignItems:'flex-start',    /* anchor to top so content isn't hidden behind keyboard */
            justifyContent:'center',
            padding:'5vh 1rem 3rem',    /* vertical breathing room */
          }}>

          {/* Modal card — max-width constrained, never full-screen */}
          <motion.div
            initial={{scale:0.92,y:24,opacity:0}}
            animate={{scale:1,y:0,opacity:1}}
            exit={{scale:0.92,y:16,opacity:0}}
            transition={{duration:0.32,ease:[0.25,0.46,0.45,0.94]}}
            style={{
              background:'#1A0505',
              border:`2px solid ${T.redL}`,
              borderRadius:2,
              width:'100%',
              maxWidth:500,
              padding:'0',
              position:'relative',
              overflow:'hidden',
              flexShrink:0,
            }}>

            {/* Red accent bar */}
            <div style={{height:4,background:T.redL,width:'100%'}}/>

            {/* Body */}
            <div style={{padding:'2rem 1.75rem 1.75rem'}}>
              {/* Icon + headline */}
              <div style={{display:'flex',alignItems:'flex-start',gap:'0.85rem',marginBottom:'1.25rem'}}>
                <span style={{color:T.redL,flexShrink:0,marginTop:3}}>{Icons.warn}</span>
                <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(1.35rem,4.5vw,1.85rem)',fontWeight:600,color:'#fff',lineHeight:1.2,letterSpacing:'0.01em'}}>
                  WARNING: BEWARE OF FAKE PROFILES
                </h2>
              </div>

              <div style={{width:'100%',height:1,background:'rgba(192,57,43,0.25)',marginBottom:'1.25rem'}}/>

              <p style={{fontSize:'0.82rem',color:'rgba(232,224,208,0.85)',lineHeight:1.9,marginBottom:'0.9rem',letterSpacing:'0.02em'}}>
                Goddess Natasha operates exclusively on{' '}
                <strong style={{color:'#fff'}}>Instagram (@goddessnatasha000)</strong> and{' '}
                <strong style={{color:'#fff'}}>X / Twitter (@DommeNatasha001)</strong>.
                She is <em>not</em> present on any other platform.
              </p>
              <p style={{fontSize:'0.82rem',color:'rgba(232,224,208,0.85)',lineHeight:1.9,marginBottom:'0.9rem',letterSpacing:'0.02em'}}>
                Any profile claiming to be Goddess Natasha elsewhere is{' '}
                <strong style={{color:T.redL}}>fake and should be avoided immediately.</strong>
              </p>
              <p style={{fontSize:'0.82rem',color:'rgba(232,224,208,0.85)',lineHeight:1.9,marginBottom:'1.5rem',letterSpacing:'0.02em'}}>
                Only make contact via this website or the verified links below. Do not send money or personal information to unverified accounts.
              </p>

              {/* Verified links */}
              <div style={{display:'flex',gap:'0.6rem',flexWrap:'wrap',marginBottom:'1.75rem'}}>
                {[
                  {label:'✓  Instagram — @goddessnatasha000', href:'https://instagram.com/goddessnatasha000'},
                  {label:'✓  Twitter — @DommeNatasha001',     href:'https://twitter.com/DommeNatasha001'},
                ].map(l=>(
                  <a key={l.label} href={l.href} target="_blank" rel="noreferrer"
                    style={{fontSize:'0.58rem',letterSpacing:'0.12em',textTransform:'uppercase',color:T.gold,border:`1px solid ${T.goldD}`,padding:'0.45rem 0.85rem',textDecoration:'none',display:'inline-block',lineHeight:1.6}}>
                    {l.label}
                  </a>
                ))}
              </div>

              {/* Dismiss */}
              <button onClick={dismiss}
                style={{width:'100%',background:T.redL,border:'none',color:'#fff',fontFamily:"'Montserrat',sans-serif",fontSize:'0.62rem',letterSpacing:'0.25em',textTransform:'uppercase',padding:'0.95rem 1rem',cursor:'pointer',fontWeight:500,transition:'background .3s',borderRadius:0}}
                onMouseEnter={e=>e.currentTarget.style.background='#a93226'}
                onMouseLeave={e=>e.currentTarget.style.background=T.redL}>
                I Understand — Enter the Site
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

/* ════════════════════════════════════════════════════════════════════
   NAV
════════════════════════════════════════════════════════════════════ */
const NAV_LINKS = ['Philosophy','Sessions','Gallery','Cinema','Offerings','Testimonials','Contact'];

function Nav({onMenu}){
  const [sc,setSc]=useState(false);
  useEffect(()=>{
    const fn=()=>setSc(window.scrollY>55);
    window.addEventListener('scroll',fn,{passive:true});
    return ()=>window.removeEventListener('scroll',fn);
  },[]);
  return(
    <nav style={{position:'fixed',top:0,left:0,right:0,zIndex:100,display:'flex',justifyContent:'space-between',alignItems:'center',padding:sc?'0.85rem 1.25rem':'1.2rem 1.25rem',background:sc?'rgba(11,11,11,0.96)':'transparent',backdropFilter:sc?'blur(14px)':'none',borderBottom:sc?`1px solid ${T.border}`:'none',transition:'all .4s'}}>
      <a href="#hero" style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.05rem',fontWeight:300,letterSpacing:'0.22em',color:T.gold,textTransform:'uppercase',textDecoration:'none'}}>Goddess Natasha</a>
      <ul className="d-nav">
        {NAV_LINKS.map(l=><li key={l}><NLink href={`#${l.toLowerCase()}`}>{l}</NLink></li>)}
      </ul>
      <a href="#sessions" className="d-nav d-cta" style={{fontSize:'0.58rem',letterSpacing:'0.2em',textTransform:'uppercase',border:`1px solid ${T.goldD}`,color:T.gold,padding:'0.55rem 1.2rem',textDecoration:'none'}}>Book Now</a>
      <button onClick={onMenu} className="m-ham" aria-label="Open menu" style={{background:'none',border:'none',cursor:'pointer',padding:4,display:'flex',flexDirection:'column',gap:5}}>
        <span style={{display:'block',width:22,height:1,background:T.gold}}/><span style={{display:'block',width:22,height:1,background:T.gold}}/><span style={{display:'block',width:22,height:1,background:T.gold}}/>
      </button>
    </nav>
  );
}
function NLink({href,children}){
  const [h,setH]=useState(false);
  return <a href={href} onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} style={{fontSize:'0.6rem',letterSpacing:'0.16em',textTransform:'uppercase',color:h?T.gold:T.textM,textDecoration:'none',transition:'color .3s'}}>{children}</a>;
}

/* ─── MOBILE DRAWER ─────────────────────────────────────────────────── */
function Drawer({open,onClose}){
  useEffect(()=>{document.body.style.overflow=open?'hidden':'';},[open]);
  return(
    <AnimatePresence>
      {open&&(
        <motion.div initial={{x:'100%'}} animate={{x:0}} exit={{x:'100%'}} transition={{duration:0.38,ease:[0.25,0.46,0.45,0.94]}}
          style={{position:'fixed',inset:0,background:T.bg,zIndex:200,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:'1.6rem'}}>
          <button onClick={onClose} style={{position:'absolute',top:'1.4rem',right:'1.4rem',width:38,height:38,border:`1px solid ${T.border}`,background:'none',color:T.textM,cursor:'pointer',fontSize:'1.1rem'}}>✕</button>
          {NAV_LINKS.map((l,i)=>(
            <motion.a key={l} href={`#${l.toLowerCase()}`} onClick={onClose}
              initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} transition={{delay:i*0.055}}
              style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.9rem',fontWeight:300,color:T.text,letterSpacing:'0.08em',textDecoration:'none'}}>
              {l}
            </motion.a>
          ))}
          <div style={{display:'flex',gap:'0.7rem',marginTop:'0.5rem'}}>
            {SOCIALS.map(s=><SIcon key={s.id} s={s}/>)}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

/* ════════════════════════════════════════════════════════════════════
   HERO
════════════════════════════════════════════════════════════════════ */
function Hero(){
  return(
    <section id="hero" style={{position:'relative',minHeight:'100svh',display:'flex',alignItems:'flex-end',overflow:'hidden'}}>
      <div style={{position:'absolute',inset:0}}>
        <img src={IMAGES.hero} alt="Goddess Natasha" style={{width:'100%',height:'100%',objectFit:'cover',objectPosition:'center top',filter:'brightness(0.5)'}}/>
        <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,rgba(11,11,11,1) 0%,rgba(11,11,11,0.5) 45%,rgba(11,11,11,0.05) 100%)'}}/>
      </div>
      <div style={{position:'absolute',inset:0,backgroundImage:`linear-gradient(${T.border} 1px,transparent 1px),linear-gradient(90deg,${T.border} 1px,transparent 1px)`,backgroundSize:'48px 48px',opacity:0.22}}/>
      <div style={{position:'relative',zIndex:2,width:'100%',padding:'0 1.25rem 3.5rem'}}>
        <motion.p initial={{opacity:0,y:14}} animate={{opacity:1,y:0}} transition={{delay:0.3,duration:0.8}} style={{fontSize:'0.56rem',letterSpacing:'0.44em',textTransform:'uppercase',color:T.gold,marginBottom:'1rem'}}>An Invitation to Surrender</motion.p>
        <motion.h1 initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{delay:0.5,duration:0.9}} style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(3.6rem,16vw,9rem)',fontWeight:300,lineHeight:0.88,letterSpacing:'-0.02em',color:'#fff',marginBottom:'1.1rem'}}>
          Goddess<br/><em style={{fontStyle:'italic',color:T.gold}}>Natasha</em>
        </motion.h1>
        <motion.div initial={{opacity:0,scaleX:0}} animate={{opacity:1,scaleX:1}} transition={{delay:0.7,duration:0.6}} style={{width:48,height:1,background:T.gold,margin:'1.2rem 0',transformOrigin:'left'}}/>
        <motion.p initial={{opacity:0,y:12}} animate={{opacity:1,y:0}} transition={{delay:0.9,duration:0.8}} style={{fontSize:'0.6rem',letterSpacing:'0.28em',textTransform:'uppercase',color:T.textM,lineHeight:2,marginBottom:'1.8rem'}}>Superiority · Elegance · Absolute Control</motion.p>
        <motion.div initial={{opacity:0,y:12}} animate={{opacity:1,y:0}} transition={{delay:1.1,duration:0.8}} style={{display:'flex',gap:'0.85rem',flexWrap:'wrap'}}>
          <Btn href="#sessions" solid>View Sessions</Btn>
          <Btn href="#philosophy">Learn More</Btn>
        </motion.div>
      </div>
      <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{delay:1.6}} style={{position:'absolute',bottom:'1.4rem',right:'1.4rem'}}>
        <motion.div animate={{y:[0,7,0]}} transition={{duration:2,repeat:Infinity,ease:'easeInOut'}} style={{width:1,height:28,background:`linear-gradient(to bottom,${T.gold},transparent)`}}/>
      </motion.div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════════════
   PHILOSOPHY
════════════════════════════════════════════════════════════════════ */
function Philosophy(){
  return(
    <section id="philosophy" style={{padding:'5rem 0',background:T.bg2}}>
      <div className="cn">
        <div className="phil-grid">
          <Reveal variants={fadeLeft} className="phil-img">
            <div style={{position:'relative'}}>
              <img src={IMAGES.phil} alt="Goddess Natasha" style={{width:'100%',aspectRatio:'3/4',objectFit:'cover',objectPosition:'top',filter:'brightness(0.72)',display:'block'}}/>
              <div style={{position:'absolute',inset:-8,border:`1px solid ${T.border}`,pointerEvents:'none',zIndex:-1}}/>
              <div style={{position:'absolute',bottom:-14,right:-14,width:'55%',height:'55%',border:`1px solid ${T.goldD}`,zIndex:-1}}/>
            </div>
          </Reveal>
          <Reveal variants={fadeRight}>
            <SLabel>The Philosophy of Control</SLabel>
            <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(2rem,6vw,3.4rem)',fontWeight:300,lineHeight:1.1,color:'#fff',marginBottom:'1rem',textAlign:'left'}}>
              Power is not<br/><em style={{fontStyle:'italic',color:T.gold}}>taken. It is given.</em>
            </h2>
            <div style={{width:34,height:1,background:T.gold,margin:'1.1rem 0'}}/>
            <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(1.1rem,3vw,1.5rem)',fontStyle:'italic',fontWeight:300,color:T.text,lineHeight:1.75,marginBottom:'1.3rem'}}>"True dominance does not announce itself. It simply… is."</p>
            <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2.2,marginBottom:'1.2rem',letterSpacing:'0.04em'}}>Goddess Natasha operates in a realm beyond the ordinary — where intellect, beauty, and authority converge. Her world is not one of aggression, but of elegant inevitability. You do not simply submit to her. You discover your natural place.</p>
            <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2.2,marginBottom:'1.8rem',letterSpacing:'0.04em'}}>She receives only those genuinely prepared to explore the profound architecture of power exchange — conducted always with discretion, artistry, and absolute psychological precision.</p>
            <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.15rem',fontStyle:'italic',color:T.gold}}>— Goddess Natasha</span>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════════════
   SESSIONS PAGE
════════════════════════════════════════════════════════════════════ */
function Sessions(){
  const [activeTab,setActiveTab]=useState('sessions'); // sessions | pricing | expectations | cancellation

  return(
    <section id="sessions" style={{padding:'5rem 0',background:T.bg}}>
      <div className="cn">
        <Reveal>
          <SHeader label="Available Sessions" title={<>What She<br/><em style={{fontStyle:'italic',color:T.gold}}>Offers</em></>}
            sub="An extensive menu of power exchange. All sessions conducted with discretion, safety, and total authority."/>
        </Reveal>

        {/* Tab switcher */}
        <Reveal>
          <div style={{display:'flex',flexWrap:'wrap',gap:'1px',background:T.border,marginBottom:'3rem'}}>
            {[
              {id:'sessions',    label:'Session Menu'},
              {id:'pricing',     label:'Session Prices'},
              {id:'expectations',label:'Expectations'},
              {id:'cancellation',label:'Cancellation Policy'},
            ].map(t=>(
              <button key={t.id} onClick={()=>setActiveTab(t.id)}
                style={{flex:'1 1 auto',minWidth:130,background:activeTab===t.id?T.gold:T.bg3,color:activeTab===t.id?T.bg:T.textM,fontFamily:"'Montserrat',sans-serif",fontSize:'0.58rem',letterSpacing:'0.18em',textTransform:'uppercase',padding:'0.9rem 0.5rem',border:'none',cursor:'pointer',transition:'all .3s',fontWeight:activeTab===t.id?500:300}}>
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>

        {/* ── SESSION MENU ─────────────────────────── */}
        <AnimatePresence mode="wait">
          {activeTab==='sessions'&&(
            <motion.div key="sessions" initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-10}} transition={{duration:0.4}}>
              {/* Warning notice */}
              <div style={{border:`1px solid rgba(192,57,43,0.4)`,background:'rgba(139,26,26,0.08)',padding:'1rem 1.25rem',marginBottom:'2.5rem',display:'flex',gap:'0.9rem',alignItems:'flex-start'}}>
                <span style={{color:T.redL,flexShrink:0,marginTop:2}}>{Icons.warn}</span>
                <p style={{fontSize:'0.75rem',color:'rgba(232,224,208,0.75)',lineHeight:1.9,letterSpacing:'0.03em'}}>
                  Sessions marked <span style={{color:T.redL,fontWeight:500}}>⚠ Extreme</span> involve activities with significant physical risk. All extreme sessions require prior consultation, health disclosure, and explicit consent agreements. Goddess Natasha reserves the right to refuse any session request.
                </p>
              </div>
              <div className="sessions-grid">
                {SESSION_CATEGORIES.map((cat,i)=>(
                  <Reveal key={cat.title} custom={i*0.04}>
                    <SessionCard cat={cat}/>
                  </Reveal>
                ))}
              </div>
            </motion.div>
          )}

          {/* ── PRICING ─────────────────────────────── */}
          {activeTab==='pricing'&&(
            <motion.div key="pricing" initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-10}} transition={{duration:0.4}}>
              <div style={{maxWidth:700,margin:'0 auto'}}>
                <Reveal>
                  <p style={{fontSize:'0.75rem',color:T.textM,lineHeight:2,marginBottom:'2.5rem',textAlign:'center',letterSpacing:'0.05em'}}>
                    All prices are in the agreed currency. A deposit is required to confirm all bookings. Contact Goddess Natasha to discuss and arrange your session.
                  </p>
                </Reveal>
                <div style={{display:'flex',flexDirection:'column',gap:'1px',background:T.border}}>
                  {PRICES.map((p,i)=><PriceRow key={p.duration} p={p} i={i}/>)}
                </div>
                <Reveal>
                  <div style={{marginTop:'2.5rem',border:`1px solid ${T.border}`,padding:'1.5rem',background:T.bg2}}>
                    <p style={{fontSize:'0.6rem',letterSpacing:'0.3em',textTransform:'uppercase',color:T.gold,marginBottom:'0.8rem'}}>Deposit Information</p>
                    <p style={{fontSize:'0.78rem',color:T.textM,lineHeight:2,letterSpacing:'0.04em'}}>
                      A non-refundable deposit is required to secure your booking. The deposit amount will be confirmed upon booking. Deposits can be paid via Throne Wishlist, Gift Cards, or Bitcoin. Please review the cancellation policy before booking.
                    </p>
                  </div>
                </Reveal>
                <div style={{textAlign:'center',marginTop:'2.5rem'}}>
                  <Btn href="#contact" solid>Book a Session</Btn>
                </div>
              </div>
            </motion.div>
          )}

          {/* ── EXPECTATIONS ────────────────────────── */}
          {activeTab==='expectations'&&(
            <motion.div key="expectations" initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-10}} transition={{duration:0.4}}>
              <div style={{maxWidth:700,margin:'0 auto'}}>
                <Reveal>
                  <div style={{marginBottom:'2rem',textAlign:'center'}}>
                    <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(1.1rem,3vw,1.5rem)',fontStyle:'italic',color:T.text,lineHeight:1.75,marginBottom:'0.5rem'}}>
                      "Obedience begins before you arrive. These are not requests."
                    </p>
                    <span style={{fontSize:'0.62rem',letterSpacing:'0.25em',textTransform:'uppercase',color:T.gold}}>— Goddess Natasha</span>
                  </div>
                </Reveal>
                <div style={{display:'flex',flexDirection:'column',gap:'1px',background:T.border}}>
                  {[
                    { num:'01', title:'Arrive On Time', body:'Punctuality is a form of respect. If extenuating circumstances will cause you to be late, you must text to let Her know in advance — otherwise you risk having your session cancelled without refund.' },
                    { num:'02', title:'Impeccable Hygiene', body:'Arrive freshly showered and completely clean. This is non-negotiable and applies to every part of your body. Failure to comply will result in immediate dismissal.' },
                    { num:'03', title:'Absolute Respect', body:'Any rude, disrespectful, or entitled behaviour will not be tolerated under any circumstances. You are a guest in Her domain. Conduct yourself accordingly at all times.' },
                    { num:'04', title:'Do Not Touch Her', body:'You will NOT touch Goddess Natasha without explicit permission. Should you forget this rule, you will find your hands struck with a wooden cane. Consider this a courtesy warning.' },
                  ].map((e,i)=>(
                    <Reveal key={e.num} custom={i*0.08}>
                      <div style={{background:T.bg2,padding:'1.8rem 1.5rem',display:'flex',gap:'1.2rem',alignItems:'flex-start'}}>
                        <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'2.2rem',fontWeight:300,color:T.goldD,lineHeight:1,flexShrink:0,minWidth:42}}>{e.num}</span>
                        <div>
                          <p style={{fontSize:'0.6rem',letterSpacing:'0.25em',textTransform:'uppercase',color:T.gold,marginBottom:'0.5rem'}}>{e.title}</p>
                          <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2,letterSpacing:'0.03em'}}>{e.body}</p>
                        </div>
                      </div>
                    </Reveal>
                  ))}
                </div>
              </div>
            </motion.div>
          )}

          {/* ── CANCELLATION ────────────────────────── */}
          {activeTab==='cancellation'&&(
            <motion.div key="cancellation" initial={{opacity:0,y:16}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-10}} transition={{duration:0.4}}>
              <div style={{maxWidth:700,margin:'0 auto'}}>
                <Reveal>
                  <div style={{border:`1px solid ${T.border}`,padding:'2rem 1.5rem',background:T.bg2,marginBottom:'1.5rem'}}>
                    <div style={{display:'flex',gap:'0.9rem',alignItems:'center',marginBottom:'1.4rem'}}>
                      <span style={{color:T.gold}}>{Icons.cancel}</span>
                      <p style={{fontSize:'0.6rem',letterSpacing:'0.3em',textTransform:'uppercase',color:T.gold}}>Cancellation Policy</p>
                    </div>
                    <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(1rem,3vw,1.35rem)',color:T.text,lineHeight:1.8,marginBottom:'1.5rem'}}>
                      Goddess Natasha's time is valuable. Cancellations are taken seriously.
                    </p>
                    <div style={{display:'flex',flexDirection:'column',gap:'1px',background:T.border}}>
                      {[
                        { icon:Icons.check, color:'#2ecc71', title:'48+ Hours Notice', body:'If you cancel with at least 48 hours notice, your deposit will NOT be refunded, but it can be applied towards a future session booking.' },
                        { icon:Icons.cancel, color:T.redL, title:'Less Than 48 Hours Notice', body:'If you fail to provide 48 hours notice, your deposit will be forfeited entirely. It will not be refunded and cannot be applied to future sessions.' },
                        { icon:Icons.clock,  color:T.gold, title:'No-Show', body:'Failing to attend without any notice whatsoever will result in immediate blacklisting. You will not be considered for future sessions under any circumstances.' },
                      ].map((row,i)=>(
                        <Reveal key={row.title} custom={i*0.08}>
                          <div style={{background:T.bg3,padding:'1.5rem',display:'flex',gap:'1rem',alignItems:'flex-start'}}>
                            <span style={{color:row.color,flexShrink:0,marginTop:2}}>{row.icon}</span>
                            <div>
                              <p style={{fontSize:'0.62rem',letterSpacing:'0.22em',textTransform:'uppercase',color:row.color,marginBottom:'0.5rem'}}>{row.title}</p>
                              <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2,letterSpacing:'0.03em'}}>{row.body}</p>
                            </div>
                          </div>
                        </Reveal>
                      ))}
                    </div>
                  </div>
                  <p style={{fontSize:'0.72rem',color:T.textD,textAlign:'center',letterSpacing:'0.05em',lineHeight:1.9}}>
                    By booking a session, you agree to this cancellation policy in full. No exceptions will be made.
                  </p>
                </Reveal>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}

function SessionCard({cat}){
  const [open,setOpen]=useState(false);
  return(
    <div style={{border:`1px solid ${cat.warning?'rgba(192,57,43,0.3)':T.border}`,background:open?(cat.warning?'rgba(139,26,26,0.06)':'rgba(197,160,89,0.03)'):T.bg2,transition:'all .35s'}}>
      <button onClick={()=>setOpen(o=>!o)}
        style={{width:'100%',background:'none',border:'none',padding:'1.2rem 1.25rem',display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer',textAlign:'left'}}>
        <div style={{display:'flex',alignItems:'center',gap:'0.7rem'}}>
          <span style={{fontSize:'1rem'}}>{cat.icon}</span>
          <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.1rem',fontWeight:400,color:'#fff',letterSpacing:'0.02em'}}>
            {cat.title}
            {cat.warning&&<span style={{fontSize:'0.55rem',letterSpacing:'0.2em',color:T.redL,marginLeft:'0.6rem',verticalAlign:'middle'}}>⚠ EXTREME</span>}
          </span>
        </div>
        <motion.span animate={{rotate:open?45:0}} transition={{duration:0.25}} style={{color:T.gold,fontSize:'1.3rem',flexShrink:0,marginLeft:'0.5rem'}}>+</motion.span>
      </button>
      <AnimatePresence>
        {open&&(
          <motion.div initial={{height:0,opacity:0}} animate={{height:'auto',opacity:1}} exit={{height:0,opacity:0}} transition={{duration:0.3}} style={{overflow:'hidden'}}>
            <div style={{padding:'0 1.25rem 1.25rem'}}>
              <div style={{display:'flex',flexWrap:'wrap',gap:'0.5rem'}}>
                {cat.items.map(item=>{
                  const isPlaceholder=item.startsWith('—');
                  return(
                    <span key={item} style={{fontSize:'0.7rem',color:isPlaceholder?T.textD:T.textM,border:`1px solid ${isPlaceholder?T.border:(cat.warning?'rgba(192,57,43,0.25)':T.border)}`,padding:'0.35rem 0.7rem',letterSpacing:'0.04em',fontStyle:isPlaceholder?'italic':'normal'}}>
                      {item}
                    </span>
                  );
                })}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function PriceRow({p,i}){
  const [h,setH]=useState(false);
  const isON=p.duration==='Overnight';
  return(
    <motion.div initial={{opacity:0,x:-20}} whileInView={{opacity:1,x:0}} viewport={{once:true,margin:'-30px'}} transition={{duration:0.5,delay:i*0.07}}
      onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'1.3rem 1.5rem',background:h?'rgba(197,160,89,0.05)':T.bg2,transition:'background .3s',flexWrap:'wrap',gap:'0.5rem',borderLeft:isON?`3px solid ${T.gold}`:'3px solid transparent'}}>
      <div style={{display:'flex',alignItems:'center',gap:'0.8rem'}}>
        <span style={{color:T.gold}}>{Icons.clock}</span>
        <div>
          <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.25rem',fontWeight:400,color:'#fff',lineHeight:1}}>{p.duration}</p>
          <p style={{fontSize:'0.6rem',letterSpacing:'0.2em',textTransform:'uppercase',color:T.textD,marginTop:'0.2rem'}}>{p.note}</p>
        </div>
      </div>
      <div style={{textAlign:'right'}}>
        <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.6rem',fontWeight:300,color:T.gold,lineHeight:1}}>{p.price}</p>
        <p style={{fontSize:'0.55rem',letterSpacing:'0.2em',textTransform:'uppercase',color:T.textD,marginTop:'0.2rem'}}>Per Session</p>
      </div>
    </motion.div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   GALLERY
════════════════════════════════════════════════════════════════════ */
function Gallery(){
  const [lb,setLb]=useState(null);
  const close=useCallback(()=>{setLb(null);document.body.style.overflow='';},[]);
  const open =useCallback(i=>{setLb(i);document.body.style.overflow='hidden';},[]);
  const nav  =useCallback(d=>setLb(i=>(i+d+IMAGES.gallery.length)%IMAGES.gallery.length),[]);
  useEffect(()=>{
    const fn=e=>{if(lb===null)return;if(e.key==='ArrowRight')nav(1);if(e.key==='ArrowLeft')nav(-1);if(e.key==='Escape')close();};
    window.addEventListener('keydown',fn);
    return ()=>window.removeEventListener('keydown',fn);
  },[lb,nav,close]);
  return(
    <section id="gallery" style={{padding:'5rem 0',background:T.bg}}>
      <div className="cn">
        <Reveal><SHeader label="The Picture Vault" title={<>A Study in<br/><em style={{fontStyle:'italic',color:T.gold}}>Presence</em></>}/></Reveal>
        <div className="masonry">
          {IMAGES.gallery.map((src,i)=><GItem key={src} src={src} i={i} onOpen={()=>open(i)}/>)}
        </div>
      </div>
      <AnimatePresence>
        {lb!==null&&(
          <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
            onClick={e=>{if(e.target===e.currentTarget)close();}}
            style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.97)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center'}}>
            <button onClick={close} style={{position:'absolute',top:'1rem',right:'1rem',width:38,height:38,border:`1px solid ${T.border}`,background:'none',color:T.textM,cursor:'pointer',fontSize:'1rem'}}>✕</button>
            <button onClick={()=>nav(-1)} style={{position:'absolute',left:'0.8rem',top:'50%',transform:'translateY(-50%)',width:36,height:54,border:`1px solid ${T.border}`,background:'none',color:T.textM,cursor:'pointer',fontSize:'1.5rem'}}>‹</button>
            <motion.img key={lb} src={IMAGES.gallery[lb]} alt="" initial={{opacity:0,scale:0.96}} animate={{opacity:1,scale:1}} transition={{duration:0.28}} style={{maxHeight:'88vh',maxWidth:'88vw',objectFit:'contain'}}/>
            <button onClick={()=>nav(1)} style={{position:'absolute',right:'0.8rem',top:'50%',transform:'translateY(-50%)',width:36,height:54,border:`1px solid ${T.border}`,background:'none',color:T.textM,cursor:'pointer',fontSize:'1.5rem'}}>›</button>
            <div style={{position:'absolute',bottom:'1.2rem',left:'50%',transform:'translateX(-50%)',fontSize:'0.56rem',letterSpacing:'0.3em',color:T.textD}}>{lb+1} / {IMAGES.gallery.length}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
function GItem({src,i,onOpen}){
  const [h,setH]=useState(false);
  const ref=useRef(null);
  const inV=useInView(ref,{once:true,margin:'-30px'});
  return(
    <motion.div ref={ref} initial={{opacity:0,y:16}} animate={inV?{opacity:1,y:0}:{}} transition={{duration:0.6,delay:(i%3)*0.07}}
      onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} onClick={onOpen}
      style={{position:'relative',overflow:'hidden',cursor:'pointer',breakInside:'avoid',marginBottom:8}}>
      <img src={src} alt="" style={{width:'100%',display:'block',transition:'transform .75s,filter .45s',transform:h?'scale(1.06)':'scale(1)',filter:h?'brightness(0.62)':'brightness(0.88)'}}/>
      <motion.div animate={{opacity:h?1:0}} style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{width:36,height:36,border:`1px solid ${T.gold}`,display:'flex',alignItems:'center',justifyContent:'center',color:T.gold,fontSize:'1.3rem'}}>+</div>
      </motion.div>
    </motion.div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   CINEMA
════════════════════════════════════════════════════════════════════ */
function Cinema(){
  const [av,setAv]=useState(null);
  const closeV=()=>{setAv(null);document.body.style.overflow='';};
  useEffect(()=>{const fn=e=>{if(e.key==='Escape'&&av)closeV();};window.addEventListener('keydown',fn);return ()=>window.removeEventListener('keydown',fn);},[av]);
  return(
    <section id="cinema" style={{padding:'5rem 0',background:T.bg3}}>
      <div className="cn">
        <Reveal><SHeader label="The Cinema" title={<>Moments of<br/><em style={{fontStyle:'italic',color:T.gold}}>Authority</em></>}/></Reveal>
        <div className="vgrid">
          {VIDEOS.map((v,i)=><Reveal key={v.src} custom={i*0.1}><VCard {...v} onPlay={()=>{setAv(v.src);document.body.style.overflow='hidden';}}/></Reveal>)}
        </div>
      </div>
      <AnimatePresence>
        {av&&(
          <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} onClick={e=>{if(e.target===e.currentTarget)closeV();}}
            style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.97)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
            <button onClick={closeV} style={{position:'absolute',top:'1.2rem',right:'1.2rem',width:36,height:36,border:'1px solid rgba(255,255,255,0.2)',background:'none',color:'rgba(255,255,255,0.6)',cursor:'pointer',fontSize:'1rem'}}>✕</button>
            <video src={av} controls autoPlay playsInline style={{maxWidth:'95vw',maxHeight:'90vh',outline:'none'}}/>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
function VCard({src,label,onPlay}){
  const [h,setH]=useState(false);
  const vr=useRef(null);
  return(
    <div onMouseEnter={()=>{setH(true);vr.current?.play().catch(()=>{});}} onMouseLeave={()=>{setH(false);if(vr.current){vr.current.pause();vr.current.currentTime=0;}}} onClick={onPlay}
      style={{position:'relative',aspectRatio:'9/16',overflow:'hidden',cursor:'pointer',background:'#0d0d0d'}}>
      <video ref={vr} src={src} muted loop playsInline preload="metadata" style={{width:'100%',height:'100%',objectFit:'cover',filter:h?'brightness(0.82)':'brightness(0.48)',transition:'filter .5s'}}/>
      <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:'0.75rem'}}>
        <motion.div animate={{scale:h?1.1:1,background:h?T.gold:'transparent'}} transition={{duration:0.32}}
          style={{width:58,height:58,borderRadius:'50%',border:`1.5px solid ${T.gold}`,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <svg viewBox="0 0 24 24" style={{width:18,height:18,marginLeft:4,fill:h?T.bg:T.gold,transition:'fill .32s'}}><polygon points="5,3 19,12 5,21"/></svg>
        </motion.div>
        <span style={{fontSize:'0.56rem',letterSpacing:'0.3em',textTransform:'uppercase',color:T.gold}}>{label}</span>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   ARSENAL
════════════════════════════════════════════════════════════════════ */
function Arsenal(){
  return(
    <section id="arsenal" style={{padding:'5rem 0',background:T.bg2}}>
      <div className="cn">
        <div className="ars-grid">
          <Reveal variants={fadeLeft}>
            <img src={IMAGES.tools1} alt="" style={{width:'100%',aspectRatio:'4/3',objectFit:'cover',filter:'brightness(0.58) saturate(0.7)',display:'block',marginBottom:10}}/>
            <img src={IMAGES.tools2} alt="" style={{width:'100%',aspectRatio:'4/3',objectFit:'cover',filter:'brightness(0.58) saturate(0.7)',display:'block'}}/>
          </Reveal>
          <Reveal variants={fadeRight}>
            <SLabel>The Arsenal</SLabel>
            <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(2rem,5vw,3.2rem)',fontWeight:300,color:'#fff',lineHeight:1.1,marginBottom:'1rem',textAlign:'left'}}>Instruments of<br/><em style={{fontStyle:'italic',color:T.gold}}>Precision</em></h2>
            <div style={{width:34,height:1,background:T.gold,margin:'1.1rem 0'}}/>
            <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2.2,marginBottom:'1.2rem',letterSpacing:'0.03em'}}>Every implement is an extension of her will — chosen with the same deliberate care she applies to all things. The restraints, the leather, the chain. Each object is a language; she is fluent in them all.</p>
            <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2.2,marginBottom:'1.8rem',letterSpacing:'0.03em'}}>Sessions are conducted with an artisan's eye for detail and a psychologist's understanding of the human condition. Her arsenal serves not violence, but transformation.</p>
            <Btn href="#sessions">View Session Menu</Btn>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════════════
   OFFERINGS / MEMBERSHIP TIERS
════════════════════════════════════════════════════════════════════ */
const TIERS=[
  {name:'The Devotee',price:'Entry — By Tribute',featured:false,badge:'Begin Here',
   features:['Access to the private gallery vault','Monthly personalized audio message','Written acknowledgment from Goddess Natasha','Tasks & assignments at Her discretion','Entry to the devotee community'],
   cta:'Begin Your Journey',subj:'Devotee Tier Inquiry'},
  {name:'The Inner Circle',price:'Exclusive — Monthly Tribute',featured:true,badge:'Most Sought',
   features:['All Devotee privileges','Exclusive video content — weekly','Live text sessions (limited availability)','Custom voice notes & directives','Priority in-person session booking','Wishlist gifting with acknowledgment'],
   cta:'Claim Your Place',subj:'Inner Circle Inquiry'},
  {name:'The Sovereign',price:'Elite — Application Required',featured:false,badge:'By Application',
   features:['All Inner Circle privileges','One in-person session per month','Full psychological training programme','24/7 protocol and daily contact','Bespoke ownership contract','Named on the Sovereign register'],
   cta:'Apply for Consideration',subj:'Sovereign Tier Application'},
];
function Offerings(){
  return(
    <section id="offerings" style={{padding:'5rem 0',background:T.bg}}>
      <div className="cn">
        <Reveal><SHeader label="Offerings" title={<>Choose Your<br/><em style={{fontStyle:'italic',color:T.gold}}>Devotion</em></>} sub="Three paths of surrender. Each one a covenant. Each one a privilege."/></Reveal>
        <div className="tgrid">{TIERS.map((t,i)=><TCard key={t.name} tier={t} delay={i*0.1}/>)}</div>
        <Ornament/>
      </div>
    </section>
  );
}
function TCard({tier,delay}){
  const [h,setH]=useState(false);
  const [tilt,setTilt]=useState({x:0,y:0});
  const ref=useRef(null);
  const inV=useInView(ref,{once:true,margin:'-40px'});
  const onM=e=>{const r=e.currentTarget.getBoundingClientRect();setTilt({x:((e.clientY-r.top)/r.height-0.5)*7,y:((e.clientX-r.left)/r.width-0.5)*-7});};
  return(
    <motion.div ref={ref} initial={{opacity:0,y:26}} animate={inV?{opacity:1,y:0}:{}} transition={{duration:0.8,delay}}
      onMouseEnter={()=>setH(true)} onMouseLeave={()=>{setH(false);setTilt({x:0,y:0});}} onMouseMove={onM}
      style={{background:tier.featured?'rgba(197,160,89,0.05)':T.bg,padding:'2.5rem 1.7rem',position:'relative',overflow:'hidden',border:`1px solid ${h||tier.featured?T.borderH:T.border}`,transform:`perspective(700px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,transition:'border-color .4s,background .4s',willChange:'transform'}}>
      <div style={{position:'absolute',top:0,left:0,right:0,height:1,background:`linear-gradient(to right,transparent,${T.gold},transparent)`,transform:`scaleX(${h||tier.featured?1:0})`,transition:'transform .55s',transformOrigin:'center'}}/>
      <span style={{fontSize:'0.52rem',letterSpacing:'0.28em',textTransform:'uppercase',color:T.gold,border:`1px solid ${tier.featured?T.gold:T.goldD}`,padding:'0.22rem 0.65rem',display:'inline-block',marginBottom:'1.4rem'}}>{tier.badge}</span>
      <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.65rem',fontWeight:300,color:'#fff',marginBottom:'0.4rem'}}>{tier.name}</h3>
      <p style={{fontSize:'0.58rem',letterSpacing:'0.18em',textTransform:'uppercase',color:T.gold,marginBottom:'1.6rem',paddingBottom:'1.6rem',borderBottom:`1px solid ${T.border}`}}>{tier.price}</p>
      <ul style={{listStyle:'none',padding:0,marginBottom:'1.8rem'}}>
        {tier.features.map(f=>(
          <li key={f} style={{fontSize:'0.74rem',color:T.textM,padding:'0.48rem 0',borderBottom:`1px solid rgba(197,160,89,0.05)`,letterSpacing:'0.04em',display:'flex',gap:'0.65rem',alignItems:'flex-start'}}>
            <span style={{width:4,height:4,background:T.goldD,borderRadius:'50%',marginTop:'0.48rem',flexShrink:0}}/>{f}
          </li>
        ))}
      </ul>
      <a href={`mailto:natashabates001@gmail.com?subject=${encodeURIComponent(tier.subj)}`}
        style={{display:'block',textAlign:'center',fontSize:'0.56rem',letterSpacing:'0.18em',textTransform:'uppercase',padding:'0.82rem',border:`1px solid ${T.gold}`,color:h||tier.featured?T.bg:T.gold,background:h||tier.featured?T.gold:'transparent',transition:'all .3s',textDecoration:'none'}}>
        {tier.cta}
      </a>
    </motion.div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TESTIMONIALS
════════════════════════════════════════════════════════════════════ */
function Testimonials(){
  return(
    <section id="testimonials" style={{padding:'5rem 0',background:T.bg3}}>
      <div className="cn">
        <Reveal>
          <SHeader label="Testimonials" title={<>Words from<br/><em style={{fontStyle:'italic',color:T.gold}}>Her Devoted</em></>}
            sub="Reflections from those who have surrendered. Shared with permission."/>
        </Reveal>
        <div className="testi-grid">
          {TESTIMONIALS.map((t,i)=>(
            <Reveal key={t.name} custom={i*0.05}>
              <TestiCard t={t} i={i}/>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
function TestiCard({t,i}){
  const [h,setH]=useState(false);
  return(
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{border:`1px solid ${h?T.borderH:T.border}`,background:h?'rgba(197,160,89,0.03)':T.bg2,padding:'2rem 1.5rem',transition:'all .35s',display:'flex',flexDirection:'column',gap:'1.2rem'}}>
      {/* Stars */}
      <div style={{display:'flex',gap:'3px'}}>
        {[0,1,2,3,4].map(s=><span key={s} style={{color:T.gold}}>{Icons.star}</span>)}
      </div>
      {/* Quote */}
      <div style={{position:'relative'}}>
        <span style={{position:'absolute',top:-8,left:-4,fontFamily:"'Cormorant Garamond',serif",fontSize:'4rem',color:T.goldD,lineHeight:1,opacity:0.5}}>"</span>
        <p style={{fontSize:'0.78rem',color:T.textM,lineHeight:2,letterSpacing:'0.03em',paddingLeft:'1rem',fontStyle:'italic'}}>{t.quote}</p>
      </div>
      {/* Name */}
      <div style={{borderTop:`1px solid ${T.border}`,paddingTop:'1rem',display:'flex',alignItems:'center',gap:'0.7rem'}}>
        <div style={{width:32,height:32,borderRadius:'50%',background:`rgba(197,160,89,0.1)`,border:`1px solid ${T.goldD}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.6rem',color:T.gold,fontWeight:500}}>
          {t.name.charAt(0)}
        </div>
        <div>
          <p style={{fontSize:'0.72rem',color:T.text,letterSpacing:'0.05em'}}>{t.name}</p>
          <p style={{fontSize:'0.55rem',letterSpacing:'0.25em',textTransform:'uppercase',color:T.gold}}>Sub</p>
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   TRIBUTE / PAYMENTS
════════════════════════════════════════════════════════════════════ */
function Tribute(){
  const [cp,setCp]=useState(false);
  const copyBTC=()=>{navigator.clipboard.writeText('3AP8cKbZsGSGzLZ7tG2DErH31kJsj3b673').then(()=>{setCp(true);setTimeout(()=>setCp(false),2600);});};
  return(
    <section id="tribute" style={{padding:'5rem 0',background:T.bg2}}>
      <div className="cn">
        <Reveal><SHeader label="Tribute" title={<>Honour Her<br/><em style={{fontStyle:'italic',color:T.gold}}>Accordingly</em></>} sub="Tribute is the first gesture of reverence — proof of intent, and the beginning of consideration."/></Reveal>
        <div className="pgrid">
          {PAYMENTS.map((p,i)=><Reveal key={p.id} custom={i*0.1}><PCard p={p} onCopy={p.copyable?copyBTC:null} copied={cp&&p.copyable}/></Reveal>)}
        </div>
      </div>
    </section>
  );
}
function PCard({p,onCopy,copied}){
  const [h,setH]=useState(false);
  return(
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{border:`1px solid ${h?T.borderH:T.border}`,padding:'1.8rem 1.4rem',background:h?'rgba(197,160,89,0.03)':T.bg3,transition:'all .35s',display:'flex',flexDirection:'column',gap:'0.9rem'}}>
      <div style={{color:T.gold,opacity:h?1:0.72}}>{p.icon}</div>
      <div>
        <p style={{fontSize:'0.58rem',letterSpacing:'0.24em',textTransform:'uppercase',color:T.gold,marginBottom:'0.35rem'}}>{p.label}</p>
        <p style={{fontSize:'0.74rem',color:T.textM,letterSpacing:'0.03em',marginBottom:'0.45rem'}}>{p.desc}</p>
        {p.copyable?<p style={{fontFamily:'monospace',fontSize:'0.6rem',color:T.goldD,wordBreak:'break-all',letterSpacing:'0.05em'}}>{p.detail}</p>:<p style={{fontSize:'0.7rem',color:T.textD}}>{p.detail}</p>}
      </div>
      {onCopy
        ?<button onClick={onCopy} style={{background:'none',border:`1px solid ${copied?T.gold:T.goldD}`,color:copied?T.gold:T.goldD,fontFamily:"'Montserrat',sans-serif",fontSize:'0.56rem',letterSpacing:'0.2em',textTransform:'uppercase',padding:'0.65rem 1.1rem',cursor:'pointer',transition:'all .3s',alignSelf:'flex-start'}}>{copied?'✓ Copied!':p.cta}</button>
        :<a href={p.href} target="_blank" rel="noreferrer" style={{border:`1px solid ${T.goldD}`,color:T.gold,fontFamily:"'Montserrat',sans-serif",fontSize:'0.56rem',letterSpacing:'0.2em',textTransform:'uppercase',padding:'0.65rem 1.1rem',transition:'all .3s',alignSelf:'flex-start',textDecoration:'none',display:'inline-block'}}>{p.cta}</a>
      }
    </div>
  );
}

/* ════════════════════════════════════════════════════════════════════
   SOCIALS SECTION
════════════════════════════════════════════════════════════════════ */
function SocialsSection(){
  return(
    <section style={{padding:'3.5rem 0',background:T.bg,borderTop:`1px solid ${T.border}`,borderBottom:`1px solid ${T.border}`}}>
      <div className="cn">
        <Reveal><p style={{fontSize:'0.56rem',letterSpacing:'0.42em',textTransform:'uppercase',color:T.gold,textAlign:'center',marginBottom:'2rem'}}>Find Her</p></Reveal>
        <div className="soc-strip">
          {SOCIALS.map((s,i)=><Reveal key={s.id} custom={i*0.07}><SocCard s={s}/></Reveal>)}
        </div>
      </div>
    </section>
  );
}
function SocCard({s}){
  const [h,setH]=useState(false);
  const off=s.handle==='Coming Soon';
  return(
    <a href={off?undefined:s.href} target={off?undefined:'_blank'} rel="noreferrer"
      onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'0.65rem',padding:'1.4rem 0.8rem',border:`1px solid ${h&&!off?T.borderH:T.border}`,background:h&&!off?'rgba(197,160,89,0.04)':'transparent',transition:'all .35s',cursor:off?'default':'pointer',textDecoration:'none',opacity:off?0.4:1}}>
      <div style={{color:h&&!off?s.color:T.textM,transition:'color .3s'}}>{s.icon}</div>
      <div style={{textAlign:'center'}}>
        <p style={{fontSize:'0.58rem',letterSpacing:'0.18em',textTransform:'uppercase',color:T.gold,marginBottom:'0.15rem'}}>{s.label}</p>
        <p style={{fontSize:'0.62rem',color:T.textM}}>{s.handle}</p>
      </div>
    </a>
  );
}

/* ════════════════════════════════════════════════════════════════════
   EXPECTATIONS SECTION (standalone)
════════════════════════════════════════════════════════════════════ */
function Expectations(){
  return(
    <section style={{padding:'5rem 0',background:T.bg2,borderTop:`1px solid ${T.border}`}}>
      <div className="cn">
        <Reveal>
          <SHeader label="Her Expectations" title={<>Rules of<br/><em style={{fontStyle:'italic',color:T.gold}}>Engagement</em></>}
            sub="These are not suggestions. They are requirements."/>
        </Reveal>
        <div style={{maxWidth:760,margin:'0 auto',display:'flex',flexDirection:'column',gap:'1px',background:T.border}}>
          {[
            {num:'01',title:'Arrive On Time',body:'Punctuality is a form of respect. If extenuating circumstances will cause you to be late, you must text to let Her know in advance — otherwise you risk having your session cancelled without refund.'},
            {num:'02',title:'Impeccable Hygiene',body:'Arrive freshly showered and completely clean. This is non-negotiable and applies to every part of your body. Failure to comply will result in immediate dismissal.'},
            {num:'03',title:'Absolute Respect',body:'Any rude, disrespectful, or entitled behaviour will not be tolerated under any circumstances. You are a guest in Her domain. Conduct yourself accordingly at all times.'},
            {num:'04',title:'Do Not Touch Her',body:"You will NOT touch Goddess Natasha without explicit permission. Should you forget this rule, you will find your hands struck with a wooden cane. Consider this a courtesy warning."},
          ].map((e,i)=>(
            <Reveal key={e.num} custom={i*0.08}>
              <div style={{background:T.bg3,padding:'1.8rem 1.5rem',display:'flex',gap:'1.2rem',alignItems:'flex-start'}}>
                <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'2rem',fontWeight:300,color:T.goldD,lineHeight:1,flexShrink:0,minWidth:38}}>{e.num}</span>
                <div>
                  <p style={{fontSize:'0.6rem',letterSpacing:'0.25em',textTransform:'uppercase',color:T.gold,marginBottom:'0.5rem'}}>{e.title}</p>
                  <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2,letterSpacing:'0.03em'}}>{e.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════════════
   CANCELLATION POLICY SECTION (standalone)
════════════════════════════════════════════════════════════════════ */
function CancellationPolicy(){
  return(
    <section style={{padding:'5rem 0',background:T.bg,borderTop:`1px solid ${T.border}`}}>
      <div className="cn">
        <Reveal>
          <SHeader label="Cancellation Policy" title={<>Her Time is<br/><em style={{fontStyle:'italic',color:T.gold}}>Irreplaceable</em></>}
            sub="By booking a session you agree to this policy in full. No exceptions will be made."/>
        </Reveal>
        <div style={{maxWidth:760,margin:'0 auto'}}>
          <Reveal>
            <p style={{fontSize:'0.82rem',color:T.textM,lineHeight:2.2,marginBottom:'2rem',letterSpacing:'0.03em',textAlign:'center'}}>
              Goddess Natasha's cancellation policy requires that you notify Her with <strong style={{color:T.text}}>at least 48 hours notice</strong> if you need to cancel your appointment.
            </p>
          </Reveal>
          <div style={{display:'flex',flexDirection:'column',gap:'1px',background:T.border}}>
            {[
              {
                icon:Icons.check, color:'#27ae60',
                title:'48+ Hours Notice Given',
                body:'Your deposit will NOT be refunded, but it can be applied towards a future session booking at Her discretion.',
              },
              {
                icon:Icons.cancel, color:T.redL,
                title:'Less Than 48 Hours Notice',
                body:'Your deposit will be forfeited entirely. It will not be refunded and cannot be applied to future sessions under any circumstances.',
              },
              {
                icon:Icons.clock, color:T.gold,
                title:'No-Show / Zero Notice',
                body:'Failing to attend without any notice will result in immediate blacklisting. You will not be considered for future sessions under any circumstances.',
              },
            ].map((row,i)=>(
              <Reveal key={row.title} custom={i*0.08}>
                <div style={{background:T.bg2,padding:'1.6rem 1.5rem',display:'flex',gap:'1rem',alignItems:'flex-start'}}>
                  <span style={{color:row.color,flexShrink:0,marginTop:2}}>{row.icon}</span>
                  <div>
                    <p style={{fontSize:'0.6rem',letterSpacing:'0.22em',textTransform:'uppercase',color:row.color,marginBottom:'0.45rem'}}>{row.title}</p>
                    <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2,letterSpacing:'0.03em'}}>{row.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════════════
   EMAILJS CONFIGURATION
   ─────────────────────────────────────────────────────────────────
   Replace the three placeholder strings below with your actual keys
   from https://www.emailjs.com after connecting your Gmail service.

   Template variables used (create these in your EmailJS template):
     {{sub_name}}          {{sub_email}}         {{sub_phone}}
     {{best_contact_time}} {{how_found}}         {{experience}}
     {{sub_type}}          {{session_length}}    {{session_date}}
     {{session_time}}      {{tribute_offered}}   {{health_issues}}
     {{about_yourself}}    {{special_requests}}  {{filming_consent}}
     {{disclaimer}}        {{terms}}
════════════════════════════════════════════════════════════════════ */
const EMAILJS_SERVICE_ID  = 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY  = 'YOUR_PUBLIC_KEY';

/* ════════════════════════════════════════════════════════════════════
   BOOKING FORM (modelled on reference images)
════════════════════════════════════════════════════════════════════ */
const EMPTY_FORM = {
  name:'', email:'', phone:'',
  best_contact_time:'', how_found:'',
  experience:'', sub_type:'',
  session_length:'', session_date:'', session_time:'',
  tribute_offered:'', health_issues:'',
  about_yourself:'', special_requests:'',
  filming_consent:'', disclaimer:false, terms:false,
};

function Contact(){
  const [form,setForm]=useState({...EMPTY_FORM});
  const [status,setStatus]=useState('idle'); // idle | sending | success | error | missing

  const set=k=>v=>setForm(f=>({...f,[k]:v}));
  const check=k=>setForm(f=>({...f,[k]:!f[k]}));

  const submit=async()=>{
    if(!form.name.trim()||!form.email.trim()||!form.phone.trim()){
      setStatus('missing'); setTimeout(()=>setStatus('idle'),4000); return;
    }
    if(!form.disclaimer||!form.terms){
      setStatus('missing'); setTimeout(()=>setStatus('idle'),4000); return;
    }

    /* Fallback to mailto if keys not yet set */
    if(EMAILJS_PUBLIC_KEY==='YOUR_PUBLIC_KEY'){
      const body=Object.entries(form).map(([k,v])=>`${k}: ${v}`).join('\n');
      window.location.href=`mailto:natashabates001@gmail.com?subject=${encodeURIComponent(`Booking Request — ${form.name}`)}&body=${encodeURIComponent(body)}`;
      return;
    }

    setStatus('sending');
    try{
      const emailjs=await import('@emailjs/browser');
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        sub_name:         form.name,
        sub_email:        form.email,
        sub_phone:        form.phone,
        best_contact_time:form.best_contact_time,
        how_found:        form.how_found,
        experience:       form.experience||'Not specified',
        sub_type:         form.sub_type||'Not specified',
        session_length:   form.session_length,
        session_date:     form.session_date,
        session_time:     form.session_time,
        tribute_offered:  form.tribute_offered,
        health_issues:    form.health_issues||'None disclosed',
        about_yourself:   form.about_yourself,
        special_requests: form.special_requests||'None',
        filming_consent:  form.filming_consent||'Not answered',
        disclaimer:       form.disclaimer?'Accepted':'Not accepted',
        terms:            form.terms?'Accepted':'Not accepted',
      }, EMAILJS_PUBLIC_KEY);
      setStatus('success');
      setForm({...EMPTY_FORM});
    }catch(err){
      console.error('EmailJS error:',err);
      setStatus('error');
    }
  };

  /* ── Field helpers ── */
  const inputStyle=(focused)=>({
    background:'rgba(255,255,255,0.04)',
    border:`1px solid ${focused?T.gold:T.border}`,
    color:T.text,
    fontFamily:"'Montserrat',sans-serif",
    fontSize:'0.82rem', fontWeight:300,
    padding:'0.85rem 1rem',
    outline:'none', letterSpacing:'0.04em',
    borderRadius:0, transition:'border-color .3s',
    width:'100%',
  });

  return(
    <section id="contact" style={{padding:'5rem 0',background:T.bg2}}>
      <div className="cn">

        {/* ── Left col: info + quick-contact ───────────── */}
        <div className="cgrid">
          <Reveal variants={fadeLeft}>
            <SLabel>Private Consultations</SLabel>
            <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'clamp(2rem,5vw,3.2rem)',fontWeight:300,color:'#fff',lineHeight:1.1,marginBottom:'1rem',textAlign:'left'}}>
              Initiate<br/><em style={{fontStyle:'italic',color:T.gold}}>Contact</em>
            </h2>
            <div style={{width:34,height:1,background:T.gold,margin:'1.1rem 0'}}/>
            <p style={{fontSize:'0.8rem',color:T.textM,lineHeight:2.2,marginBottom:'1.5rem'}}>
              <strong style={{color:T.gold,letterSpacing:'0.05em'}}>PLEASE NOTE:</strong> You must contact Goddess Natasha first before filling out this appointment booking form and check Her availability for your proposed date and time. This is important.
            </p>

            {/* Quick-contact chips */}
            <div style={{display:'flex',flexDirection:'column',gap:'0.8rem',marginBottom:'2rem'}}>
              {[
                {label:'Email',    val:'natashabates001@gmail.com', href:'mailto:natashabates001@gmail.com',        icon:Icons.email},
                {label:'Instagram',val:'@goddessnatasha000',        href:'https://instagram.com/goddessnatasha000', icon:Icons.instagram},
                {label:'Twitter',  val:'@DommeNatasha001',          href:'https://twitter.com/DommeNatasha001',     icon:Icons.twitter},
                {label:'Zangi',    val:'5815960601',                 href:'https://zangi.com',                       icon:Icons.zangi},
              ].map(c=>(
                <a key={c.label} href={c.href} target="_blank" rel="noreferrer"
                  style={{display:'flex',alignItems:'center',gap:'0.9rem',padding:'0.85rem 1rem',border:`1px solid ${T.border}`,textDecoration:'none',transition:'border-color .3s',color:'inherit'}}
                  onMouseEnter={e=>e.currentTarget.style.borderColor=T.borderH}
                  onMouseLeave={e=>e.currentTarget.style.borderColor=T.border}>
                  <span style={{color:T.gold,flexShrink:0}}>{c.icon}</span>
                  <div>
                    <p style={{fontSize:'0.52rem',letterSpacing:'0.24em',textTransform:'uppercase',color:T.goldD,marginBottom:'0.1rem'}}>{c.label}</p>
                    <p style={{fontSize:'0.74rem',color:T.textM}}>{c.val}</p>
                  </div>
                </a>
              ))}
            </div>
            <div style={{display:'flex',gap:'0.55rem',flexWrap:'wrap'}}>{SOCIALS.map(s=><SIcon key={s.id} s={s}/>)}</div>
          </Reveal>

          {/* ── Right col: booking form ───────────────── */}
          <Reveal variants={fadeRight}>
            <div style={{background:'rgba(255,255,255,0.025)',border:`1px solid ${T.border}`,padding:'2rem 1.75rem',display:'flex',flexDirection:'column',gap:'1.4rem'}}>

              {/* Form header */}
              <div style={{borderBottom:`1px solid ${T.border}`,paddingBottom:'1.2rem'}}>
                <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.4rem',fontWeight:400,color:'#fff',marginBottom:'0.4rem'}}>Appointment / Booking Form</p>
                <p style={{fontSize:'0.62rem',letterSpacing:'0.18em',textTransform:'uppercase',color:T.gold}}>Appointment Requests</p>
              </div>

              {/* ─ Basic info ─ */}
              <BF label="Name *" value={form.name} onChange={set('name')} ph="Your name"/>
              <BF label="Email Address *" type="email" value={form.email} onChange={set('email')} ph="Your email address"/>
              <BF label="Telephone *" type="tel" value={form.phone} onChange={set('phone')} ph="Your phone number"/>
              <BF label="When will it be best for Her to contact you?" value={form.best_contact_time} onChange={set('best_contact_time')} ph="e.g. Evenings after 7pm"/>
              <BF label="How did you find Her? (website link, social media, referral…)" value={form.how_found} onChange={set('how_found')} ph=""/>

              {/* ─ Experience dropdown ─ */}
              <BSelect label="Experience" value={form.experience} onChange={set('experience')} options={['','No experience — complete beginner','Some experience — a few sessions','Experienced — regular sub/slave','Highly experienced — many years']}/>

              {/* ─ Which best describes you ─ */}
              <BSelect label="Which best describes you?" value={form.sub_type} onChange={set('sub_type')} options={['','Submissive','Slave','Pet','Fetishist','Masochist','Switch','Other / Prefer not to say']}/>

              {/* ─ Session logistics ─ */}
              <BSelect label="Preferred length of session" value={form.session_length} onChange={set('session_length')} options={['','1 Hour — 250','2 Hours — 400','3 Hours — 550','4 Hours — 700','5 Hours — 800','Overnight — 800 to 1600']}/>
              <BF label="Preferred session date" type="date" value={form.session_date} onChange={set('session_date')} ph=""/>
              <BF label="Preferred session time" type="time" value={form.session_time} onChange={set('session_time')} ph=""/>
              <BF label="Tribute offered" value={form.tribute_offered} onChange={set('tribute_offered')} ph="Amount you intend to tribute"/>

              {/* ─ Health issues textarea ─ */}
              <BTA label="Detail any health issues you have" value={form.health_issues} onChange={set('health_issues')} ph="Please be thorough — this is for your safety" rows={4}/>

              {/* ─ About yourself ─ */}
              <BTA label="Tell Her about yourself (Age, Location, Profession, Fantasies, Experiences, Limits, etc)" value={form.about_yourself} onChange={set('about_yourself')} ph="" rows={5}/>

              {/* ─ Special requests ─ */}
              <BTA label="Detail any special requests for Her consideration" value={form.special_requests} onChange={set('special_requests')} ph="" rows={4}/>

              {/* ─ Filming consent ─ */}
              <div style={{display:'flex',flexDirection:'column',gap:'0.75rem'}}>
                <p style={{fontSize:'0.72rem',color:T.text,lineHeight:1.8,letterSpacing:'0.03em'}}>Are you happy for Her to film or photograph your session for Her social media?</p>
                {[
                  {val:'yes_covered',  label:'Yes, as long as my face is covered'},
                  {val:'no_private',   label:'No, I would prefer to keep our session private'},
                ].map(opt=>(
                  <label key={opt.val} style={{display:'flex',alignItems:'flex-start',gap:'0.7rem',cursor:'pointer'}}>
                    <div onClick={()=>set('filming_consent')(opt.val)}
                      style={{width:18,height:18,border:`1px solid ${form.filming_consent===opt.val?T.gold:T.border}`,background:form.filming_consent===opt.val?T.gold:'transparent',flexShrink:0,marginTop:2,display:'flex',alignItems:'center',justifyContent:'center',transition:'all .25s',cursor:'pointer'}}>
                      {form.filming_consent===opt.val&&<svg viewBox="0 0 10 10" width="10" height="10"><polyline points="1.5,5 4,7.5 8.5,2.5" stroke={T.bg} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                    </div>
                    <span style={{fontSize:'0.78rem',color:T.textM,lineHeight:1.7}}>{opt.label}</span>
                  </label>
                ))}
              </div>

              {/* ─ Disclaimer ─ */}
              <div style={{background:'rgba(197,160,89,0.04)',border:`1px solid ${T.border}`,padding:'1.2rem'}}>
                <p style={{fontSize:'0.6rem',letterSpacing:'0.22em',textTransform:'uppercase',color:T.gold,marginBottom:'0.9rem'}}>DISCLAIMER (Tick to confirm your acceptance)</p>
                <CheckRow checked={form.disclaimer} onChange={()=>check('disclaimer')}
                  label="I agree that Goddess Natasha will not be held responsible for any injury resulting from our risk-aware and consensual session."/>
              </div>

              {/* ─ Terms ─ */}
              <div style={{background:'rgba(197,160,89,0.04)',border:`1px solid ${T.border}`,padding:'1.2rem'}}>
                <p style={{fontSize:'0.6rem',letterSpacing:'0.22em',textTransform:'uppercase',color:T.gold,marginBottom:'0.9rem'}}>Terms (Tick to confirm your acceptance)</p>
                <CheckRow checked={form.terms} onChange={()=>check('terms')}
                  label="I have read and understood all of the information set out on this website. I am fully aware of the activities I am requesting and how Goddess Natasha conducts Her sessions."/>
              </div>

              {/* Status messages */}
              <AnimatePresence mode="wait">
                {status==='missing'&&(
                  <motion.p key="miss" initial={{opacity:0,y:-6}} animate={{opacity:1,y:0}} exit={{opacity:0}} style={{fontSize:'0.72rem',color:T.redL,letterSpacing:'0.04em',lineHeight:1.7}}>
                    ✕ &nbsp;Please fill in Name, Email, Telephone, and tick both the Disclaimer and Terms checkboxes.
                  </motion.p>
                )}
                {status==='error'&&(
                  <motion.p key="err" initial={{opacity:0,y:-6}} animate={{opacity:1,y:0}} exit={{opacity:0}} style={{fontSize:'0.72rem',color:T.redL,letterSpacing:'0.04em'}}>
                    ✕ &nbsp;Something went wrong. Please try again or email directly.
                  </motion.p>
                )}
                {status==='success'&&(
                  <motion.p key="ok" initial={{opacity:0,y:-6}} animate={{opacity:1,y:0}} exit={{opacity:0}} style={{fontSize:'0.72rem',color:T.gold,letterSpacing:'0.04em',lineHeight:1.7}}>
                    ✦ &nbsp;Your booking request has been received. Goddess Natasha will review it and be in touch.
                  </motion.p>
                )}
              </AnimatePresence>

              {/* Submit */}
              <motion.button whileTap={{scale:0.98}} onClick={submit} disabled={status==='sending'}
                style={{background:status==='sending'?'rgba(197,160,89,0.35)':T.gold,border:'none',color:T.bg,fontFamily:"'Montserrat',sans-serif",fontSize:'0.62rem',letterSpacing:'0.25em',textTransform:'uppercase',padding:'1.1rem',cursor:status==='sending'?'not-allowed':'pointer',transition:'all .3s',fontWeight:500,width:'100%',borderRadius:0}}>
                {status==='sending'?'Submitting…':'Submit'}
              </motion.button>

              <p style={{fontSize:'0.6rem',color:T.textD,textAlign:'center',lineHeight:1.8,letterSpacing:'0.04em'}}>
                All submissions are handled with absolute discretion.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

/* ─── Booking form field helpers ────────────────────────────────── */
function BF({label,type='text',value,onChange,ph}){
  const [f,setF]=useState(false);
  return(
    <div style={{display:'flex',flexDirection:'column',gap:'0.45rem'}}>
      <span style={{fontSize:'0.56rem',letterSpacing:'0.2em',textTransform:'uppercase',color:'rgba(197,160,89,0.7)'}}>{label}</span>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={ph}
        onFocus={()=>setF(true)} onBlur={()=>setF(false)}
        style={{background:'rgba(255,255,255,0.05)',border:`1px solid ${f?T.gold:T.border}`,color:T.text,fontFamily:"'Montserrat',sans-serif",fontSize:'0.82rem',fontWeight:300,padding:'0.82rem 0.9rem',outline:'none',letterSpacing:'0.04em',borderRadius:0,transition:'border-color .3s',width:'100%'}}/>
    </div>
  );
}
function BTA({label,value,onChange,ph,rows=4}){
  const [f,setF]=useState(false);
  return(
    <div style={{display:'flex',flexDirection:'column',gap:'0.45rem'}}>
      <span style={{fontSize:'0.56rem',letterSpacing:'0.2em',textTransform:'uppercase',color:'rgba(197,160,89,0.7)'}}>{label}</span>
      <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={ph} rows={rows}
        onFocus={()=>setF(true)} onBlur={()=>setF(false)}
        style={{background:'rgba(255,255,255,0.04)',border:`1px solid ${f?T.gold:T.border}`,color:T.text,fontFamily:"'Montserrat',sans-serif",fontSize:'0.82rem',fontWeight:300,padding:'0.82rem 0.9rem',outline:'none',resize:'vertical',letterSpacing:'0.04em',lineHeight:1.8,borderRadius:0,transition:'border-color .3s',width:'100%'}}/>
    </div>
  );
}
function BSelect({label,value,onChange,options}){
  const [f,setF]=useState(false);
  return(
    <div style={{display:'flex',flexDirection:'column',gap:'0.45rem'}}>
      <span style={{fontSize:'0.56rem',letterSpacing:'0.2em',textTransform:'uppercase',color:'rgba(197,160,89,0.7)'}}>{label}</span>
      <div style={{position:'relative'}}>
        <select value={value} onChange={e=>onChange(e.target.value)}
          onFocus={()=>setF(true)} onBlur={()=>setF(false)}
          style={{width:'100%',background:'rgba(255,255,255,0.05)',border:`1px solid ${f?T.gold:T.border}`,borderRadius:0,color:value?T.text:'rgba(138,125,110,0.65)',fontFamily:"'Montserrat',sans-serif",fontSize:'0.82rem',fontWeight:300,padding:'0.82rem 2.2rem 0.82rem 0.9rem',outline:'none',cursor:'pointer',appearance:'none',WebkitAppearance:'none',transition:'border-color .3s'}}>
          {options.map((o,i)=><option key={i} value={o}>{o||'Select…'}</option>)}
        </select>
        <span style={{position:'absolute',right:'0.9rem',top:'50%',transform:'translateY(-50%)',color:T.goldD,pointerEvents:'none',fontSize:'0.7rem'}}>▾</span>
      </div>
    </div>
  );
}
function CheckRow({checked,onChange,label}){
  return(
    <label style={{display:'flex',alignItems:'flex-start',gap:'0.75rem',cursor:'pointer'}}>
      <div onClick={onChange}
        style={{width:20,height:20,border:`1px solid ${checked?T.gold:T.border}`,background:checked?T.gold:'transparent',flexShrink:0,marginTop:2,display:'flex',alignItems:'center',justifyContent:'center',transition:'all .25s',cursor:'pointer'}}>
        {checked&&<svg viewBox="0 0 12 12" width="12" height="12"><polyline points="2,6 5,9 10,3" stroke={T.bg} strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
      </div>
      <span style={{fontSize:'0.78rem',color:T.textM,lineHeight:1.8,letterSpacing:'0.03em'}}>{label}</span>
    </label>
  );
}

function SIcon({s}){
  const [h,setH]=useState(false);
  const off=s.handle==='Coming Soon';
  return(
    <a href={off?undefined:s.href} target={off?undefined:'_blank'} rel="noreferrer" title={s.label+(off?' (coming soon)':` — ${s.handle}`)}
      onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{width:36,height:36,border:`1px solid ${h&&!off?T.gold:T.border}`,display:'flex',alignItems:'center',justifyContent:'center',color:h&&!off?s.color:T.textD,transition:'all .3s',textDecoration:'none',opacity:off?0.38:1,cursor:off?'default':'pointer'}}>
      {s.icon}
    </a>
  );
}
/* keep FI for any legacy use */
function FI({label,type='text',value,onChange,ph}){
  return <BF label={label} type={type} value={value} onChange={onChange} ph={ph}/>;
}

/* ════════════════════════════════════════════════════════════════════
   FOOTER
════════════════════════════════════════════════════════════════════ */
function Footer(){
  return(
    <footer style={{background:T.bg,borderTop:`1px solid ${T.border}`,padding:'2.5rem 0'}}>
      <div className="cn">
        <div className="footer-in">
          <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:'1.05rem',fontWeight:300,letterSpacing:'0.22em',color:T.gold,textTransform:'uppercase'}}>Goddess Natasha</span>
          <div style={{display:'flex',gap:'0.55rem',flexWrap:'wrap',justifyContent:'center'}}>{SOCIALS.map(s=><SIcon key={s.id} s={s}/>)}</div>
          <p style={{fontSize:'0.55rem',letterSpacing:'0.1em',color:T.textD,textAlign:'center'}}>© {new Date().getFullYear()} Goddess Natasha. All rights reserved.<br/><span style={{opacity:0.55}}>Discretion is non-negotiable.</span></p>
          <div style={{display:'flex',gap:'1.3rem',flexWrap:'wrap',justifyContent:'center'}}>
            {NAV_LINKS.map(l=><a key={l} href={`#${l.toLowerCase()}`} style={{fontSize:'0.55rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textD,textDecoration:'none'}}>{l}</a>)}
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ════════════════════════════════════════════════════════════════════
   GLOBAL CSS — MOBILE-FIRST
════════════════════════════════════════════════════════════════════ */
const GCss=()=>(
  <style>{`
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    html{scroll-behavior:smooth}
    body{background:#0B0B0B;color:#E8E0D0;font-family:'Montserrat',sans-serif;font-weight:300;line-height:1.8;overflow-x:hidden}
    ::selection{background:#8B6E3A;color:#fff}
    ::-webkit-scrollbar{width:2px}
    ::-webkit-scrollbar-track{background:#0B0B0B}
    ::-webkit-scrollbar-thumb{background:#8B6E3A}
    input::placeholder,textarea::placeholder{color:#4A4238}
    input,textarea,select{-webkit-appearance:none;appearance:none}
    select option{background:#1a1a1a;color:#E8E0D0}
    a{text-decoration:none;color:inherit}

    .cn{max-width:1200px;margin:0 auto;padding:0 1.25rem}
    .d-nav{display:none!important;list-style:none;gap:1.5rem;margin:0;padding:0}
    .d-cta{display:none!important}
    .m-ham{display:flex!important}
    .masonry{columns:2;column-gap:8px}
    .vgrid{display:grid;grid-template-columns:1fr 1fr;gap:8px}
    .phil-grid{display:flex;flex-direction:column;gap:2.5rem}
    .phil-img{max-width:380px;width:100%;margin:0 auto}
    .ars-grid{display:flex;flex-direction:column;gap:2.5rem}
    .tgrid{display:flex;flex-direction:column;gap:1px;background:rgba(197,160,89,0.12)}
    .pgrid{display:grid;grid-template-columns:1fr;gap:1px;background:rgba(197,160,89,0.1)}
    .soc-strip{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(197,160,89,0.1)}
    .cgrid{display:flex;flex-direction:column;gap:3rem}
    .footer-in{display:flex;flex-direction:column;align-items:center;gap:1.6rem}
    .sessions-grid{display:flex;flex-direction:column;gap:1px;background:rgba(197,160,89,0.1)}
    .testi-grid{display:grid;grid-template-columns:1fr;gap:1px;background:rgba(197,160,89,0.1)}

    @media(min-width:600px){
      .cn{padding:0 2rem}
      .masonry{columns:3;column-gap:10px}
      .pgrid{grid-template-columns:repeat(3,1fr)}
      .soc-strip{grid-template-columns:repeat(6,1fr)}
      .tgrid{flex-direction:row}
      .tgrid>*{flex:1}
      .vgrid{grid-template-columns:repeat(4,1fr);gap:12px}
      .sessions-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1px}
      .testi-grid{grid-template-columns:repeat(2,1fr)}
    }

    @media(min-width:900px){
      .cn{padding:0 3.5rem}
      section{padding:7rem 0!important}
      .d-nav{display:flex!important}
      .d-cta{display:inline!important}
      .m-ham{display:none!important}
      .phil-grid{display:grid;grid-template-columns:1fr 1fr;gap:7rem;align-items:center}
      .phil-img{max-width:100%;margin:0}
      .ars-grid{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center}
      .cgrid{display:grid;grid-template-columns:1fr 1fr;gap:7rem;align-items:start}
      .footer-in{flex-direction:row;justify-content:space-between;align-items:center}
      .sessions-grid{grid-template-columns:repeat(3,1fr)}
      .testi-grid{grid-template-columns:repeat(3,1fr)}
    }

    @media(min-width:1200px){.cn{padding:0 4rem}}
  `}</style>
);

/* ════════════════════════════════════════════════════════════════════
   ROOT
════════════════════════════════════════════════════════════════════ */
export default function App(){
  const [menu,setMenu]=useState(false);
  return(
    <>
      <GCss/>
      <WarningModal/>
      <Nav onMenu={()=>setMenu(true)}/>
      <Drawer open={menu} onClose={()=>setMenu(false)}/>
      <Hero/>
      <Philosophy/>
      <Sessions/>
      <Gallery/>
      <Cinema/>
      <Arsenal/>
      <Offerings/>
      <Testimonials/>
      <Tribute/>
      <Expectations/>
      <CancellationPolicy/>
      <SocialsSection/>
      <Contact/>
      <Footer/>
    </>
  );
}
